import React, { useRef } from 'react';

export default function ImageRenderer({ src, maxWidth, onLoad }) {
  const imgRef = useRef(null);

  const handleLoad = () => {
    const img = imgRef.current;
    if (!img || !onLoad) return;
    onLoad({
      width: img.clientWidth,
      height: img.clientHeight,
      naturalWidth: img.naturalWidth,
      naturalHeight: img.naturalHeight,
    });
  };

  return (
    <img
      ref={imgRef}
      src={src}
      alt="Entrega del estudiante"
      onLoad={handleLoad}
      crossOrigin="anonymous"
      style={{
        width: '100%',
        maxWidth: maxWidth || '100%',
        display: 'block',
        userSelect: 'none',
        pointerEvents: 'none',
      }}
      draggable={false}
    />
  );
}
